module.exports = __webpack_public_path__ + "img/angsuran.8e388f2e.png";